define.alias("shared/components/shared/wizard/finish-button", "preview-grid/components/shared/wizard/finish-button");